export default __webpack_public_path__ + "static/media/017-first-aid-kit-1.73c759dc.png";